/**
 * @param {string} type
 * @param {*} value
 * @param {*} testValue
 * @param {array|undefined} dynamicContent
 * @param {array|object|undefined} options
 * @param {array|undefined} attrs
 * @param {string|undefined} filter
 * @param {string|undefined} format
 * @param {object|undefined} validation
 * @param {object|undefined} dynamicValidation
 * @param {string|undefined} blurAction
 * @param {object} props
 * @param {boolean} visibleValidation
 * @param {boolean} locked
 * @param {*} dataType
 * @param {boolean} persist
 */
const formField = (
  type = 'text',
  value = undefined,
  testValue = undefined,
  dynamicContent = undefined,
  options = undefined,
  attrs = undefined,
  filter = undefined,
  format = undefined,
  validation = undefined,
  dynamicValidation = undefined,
  blurAction = undefined,
  props = undefined,
  visibleValidation = true,
  locked = false,
  dataType = undefined,
  persist = true
) => ({
  type,
  value,
  testValue,
  dynamicContent,
  options,
  attrs,
  filter,
  format,
  validation,
  dynamicValidation,
  blurAction,
  props,
  visibleValidation,
  locked,
  dataType,
  touched: false,
  valid: false,
  disabled: false,
  persist: true
})

module.exports = { formField }
